module.exports = __webpack_public_path__ + "static/img/logo-3-3.1a84d832.png";